<div class="ayuda-page">
  <!-- Vista: Índice -->
  @if (vista === 'indice') {
    <div class="ayuda-header">
      <app-page-title
        title="Ayuda"
        subtitle="Guías y respuestas sobre cómo usar IRIX"
        icon="help_outline"
      ></app-page-title>

      <!-- Búsqueda -->
      <mat-form-field appearance="outline" class="search-field no-hint">
        <mat-icon matPrefix>search</mat-icon>
        <input
          matInput
          placeholder="Buscar en la ayuda..."
          [(ngModel)]="queryBusqueda"
          (keyup.enter)="buscar()"
          (input)="buscar()"
        />
        @if (queryBusqueda) {
          <button
            irxBotonIcono
            tooltip="Cerrar"
            matSuffix
            (click)="queryBusqueda = ''; resultadosBusqueda = []"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    </div>

    <!-- Resultados de búsqueda -->
    @if (resultadosBusqueda.length > 0) {
      <div class="search-results">
        <span class="search-results-count">
          {{ resultadosBusqueda.length }} resultado(s)
        </span>
        @for (r of resultadosBusqueda; track r.id) {
          <mat-card
            class="result-card irx-clickeable"
            role="button"
            tabindex="0"
            (click)="abrirDesdeResultado(r)"
            (keydown.enter)="abrirDesdeResultado(r)"
          >
            <mat-card-content>
              <span class="result-titulo">{{ r.titulo }}</span>
              <span class="result-fragmento">{{ r.fragmento }}</span>
            </mat-card-content>
          </mat-card>
        }
      </div>
    }

    <!-- Cards por categoría -->
    <!-- Pestañas de grupo: separan operar el sistema de configurar equipos -->
    @if (grupos.length > 1 && resultadosBusqueda.length === 0) {
      <div class="grupo-tabs">
        @for (g of grupos; track g.id) {
          <button
            class="grupo-tab irx-opcion"
            [attr.aria-pressed]="g.id === grupoActivo"
            (click)="seleccionarGrupo(g.id)"
          >
            <mat-icon class="grupo-tab-icon">
              {{ g.icono || 'article' }}
            </mat-icon>
            <span class="grupo-tab-texto">
              <span class="grupo-tab-titulo">{{ g.titulo }}</span>
              @if (g.subtitulo) {
                <span class="grupo-tab-subtitulo">{{ g.subtitulo }}</span>
              }
            </span>
          </button>
        }
      </div>
    }

    @if (resultadosBusqueda.length === 0) {
      @if (sinContenido) {
        <div class="ayuda-empty">
          <mat-icon class="empty-icon">info</mat-icon>
          <p>No hay artículos de ayuda disponibles para tu cuenta.</p>
        </div>
      }

      @for (cat of categoriasDelGrupo; track cat.id) {
        <h2 class="subtitulo" [id]="'cat-' + cat.id">
          <mat-icon class="subtitulo-icon">
            {{ cat.icono || 'article' }}
          </mat-icon>
          {{ cat.titulo }}
        </h2>
        <div class="items-grid">
          @for (sub of cat.subcategorias; track sub.id) {
            @if (sub.articulos.length === 1) {
              <!-- Subcategoría con 1 artículo: abre directo -->
              <mat-card
                class="item-card irx-clickeable"
                role="button"
                tabindex="0"
                (click)="
                  abrirArticulo({ ref: sub.articulos[0], categoria: cat })
                "
                (keydown.enter)="
                  abrirArticulo({ ref: sub.articulos[0], categoria: cat })
                "
              >
                <mat-card-content class="item-card-content">
                  <div class="item-info">
                    <span class="item-nombre">{{ sub.titulo }}</span>
                    <span class="item-resumen">
                      {{ sub.articulos[0].resumen }}
                    </span>
                  </div>
                  <mat-icon class="item-arrow">chevron_right</mat-icon>
                </mat-card-content>
              </mat-card>
            } @else {
              <!-- Subcategoría con múltiples artículos: drill-down -->
              <mat-card
                class="item-card irx-clickeable"
                role="button"
                tabindex="0"
                (click)="abrirSubcategoria(cat, sub)"
                (keydown.enter)="abrirSubcategoria(cat, sub)"
              >
                <mat-card-content class="item-card-content">
                  <div class="item-info">
                    <span class="item-nombre">{{ sub.titulo }}</span>
                    <span class="item-resumen">
                      {{ sub.articulos.length }} artículos
                    </span>
                  </div>
                  <mat-icon class="item-arrow">chevron_right</mat-icon>
                </mat-card-content>
              </mat-card>
            }
          }
        </div>
      }

      @if (bundle && !sinContenido) {
        <div class="ayuda-footer">
          <span class="muted-text">Documentación v{{ bundle.version }}</span>
        </div>
      }
    }
  }

  <!-- Vista: Subcategoría (listado de artículos) -->
  @if (vista === 'subcategoria' && subcategoriaActual) {
    <div class="vista-header">
      <button
        irxBotonIcono
        tooltip="Volver"
        (click)="volverAlIndice()"
        class="back-btn"
      >
        <mat-icon>arrow_back</mat-icon>
      </button>
      <nav class="breadcrumb" aria-label="Dónde estás en la ayuda">
        <button class="irx-enlace breadcrumb-text" (click)="volverAlIndice()">
          Ayuda
        </button>
        @if (tituloGrupoActivo) {
          <mat-icon class="breadcrumb-separator" aria-hidden="true">
            chevron_right
          </mat-icon>
          <button class="irx-enlace breadcrumb-text" (click)="volverAlIndice()">
            {{ tituloGrupoActivo }}
          </button>
        }
        @if (categoriaActual) {
          <mat-icon class="breadcrumb-separator" aria-hidden="true">
            chevron_right
          </mat-icon>
          <button
            class="irx-enlace breadcrumb-text"
            (click)="abrirCategoria(categoriaActual.id)"
          >
            {{ categoriaActual.titulo }}
          </button>
        }
        <mat-icon class="breadcrumb-separator" aria-hidden="true">
          chevron_right
        </mat-icon>
        <span class="breadcrumb-current" aria-current="page">
          {{ subcategoriaActual.titulo }}
        </span>
      </nav>
    </div>

    <h2 class="subtitulo">{{ subcategoriaActual.titulo }}</h2>
    <div class="items-list">
      @for (art of subcategoriaActual.articulos; track art.id) {
        <mat-card
          class="item-card irx-clickeable"
          role="button"
          tabindex="0"
          (click)="abrirArticuloDesdeSubcategoria(art)"
          (keydown.enter)="abrirArticuloDesdeSubcategoria(art)"
        >
          <mat-card-content class="item-card-content">
            <mat-icon class="item-icon-small">article</mat-icon>
            <div class="item-info">
              <span class="item-nombre">{{ art.titulo }}</span>
              <span class="item-resumen">{{ art.resumen }}</span>
            </div>
            <mat-icon class="item-arrow">chevron_right</mat-icon>
          </mat-card-content>
        </mat-card>
      }
    </div>
  }

  <!-- Vista: Artículo -->
  @if (vista === 'articulo' && contenidoActual) {
    <div class="vista-header">
      <button
        irxBotonIcono
        tooltip="Volver"
        (click)="volverAtras()"
        class="back-btn"
      >
        <mat-icon>arrow_back</mat-icon>
      </button>
      <nav class="breadcrumb" aria-label="Dónde estás en la ayuda">
        <button class="irx-enlace breadcrumb-text" (click)="volverAlIndice()">
          Ayuda
        </button>
        @if (tituloGrupoActivo) {
          <mat-icon class="breadcrumb-separator" aria-hidden="true">
            chevron_right
          </mat-icon>
          <button class="irx-enlace breadcrumb-text" (click)="volverAlIndice()">
            {{ tituloGrupoActivo }}
          </button>
        }
        @if (categoriaActual) {
          <mat-icon class="breadcrumb-separator" aria-hidden="true">
            chevron_right
          </mat-icon>
          <button
            class="irx-enlace breadcrumb-text"
            (click)="abrirCategoria(categoriaActual.id)"
          >
            {{ categoriaActual.titulo }}
          </button>
        }
        @if (subcategoriaActual) {
          <mat-icon class="breadcrumb-separator" aria-hidden="true">
            chevron_right
          </mat-icon>
          <button
            class="irx-enlace breadcrumb-text"
            (click)="volverASubcategoria()"
          >
            {{ subcategoriaActual.titulo }}
          </button>
        }
        <mat-icon class="breadcrumb-separator" aria-hidden="true">
          chevron_right
        </mat-icon>
        <span class="breadcrumb-current" aria-current="page">
          {{ tituloActual }}
        </span>
      </nav>
    </div>

    <div class="articulo-body">
      <markdown [data]="contenidoActual" class="articulo-contenido"></markdown>
    </div>
  }
</div>
